module.exports = __webpack_public_path__ + "img/hr-level3addon_mining_tool_mask.d6e5c703.png";